import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AnalyticsComponent } from './analytics/analytics.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProductDashboardComponent } from './product-dashboard/product-dashboard.component';
import { SalesDashboardComponent } from './sales-dashboard/sales-dashboard.component';

// Component Pages


const routes: Routes = [
   {
    path: 'analytics',
    component: AnalyticsComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent
   },
   {
    path:'product-dashboard',
    component: ProductDashboardComponent
   },
   {
    path: 'sales-dashboard',
    component: SalesDashboardComponent
   }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class DashboardsRoutingModule { }
